<template>
    <span class="feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.IsPublished">
      </vs-switch>
    </span>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  watch: {
    "params.data.IsPublished"(val) {
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("pageManagement/updateStatus", {
          id: this.params.id,
          IsPublished: val
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  methods: {
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
}
</script>